// @flow
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { containerIds, setUIState } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'

import ReservationSidebar from 'components/organisms/ReservationSidebar'
import { getReservationSidebarProps } from 'components/organisms/ReservationSidebar/presenter'

type PropTypes = {
  reservationDetail: ReservationDetailState,
  ui: {
    isShowContentsSp: boolean,
  },
  actions: {
    setUIState: Function,
    ...ReservationDetailActions,
  },
  match: {
    params: {
      ownerName: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
}

class Container extends React.Component<PropTypes, *, *> {
  constructor(props) {
    super(props)
    this.onClickLink = this.onClickLink.bind(this)
  }

  onClickLink: Function
  onClickLink(e?: ?Event, url: string, newWindow?: ?boolean) {
    const { history, location } = this.props
    if (!!e) {
      e.preventDefault()
    }
    if (newWindow) {
      window.open(url, '_blank')
    } else {
      history.push(location.pathname)
      history.replace(url)
    }
  }

  render() {
    const { reservationDetail, actions, ui } = this.props

    return (
      <ReservationSidebar
        {...getReservationSidebarProps(
          reservationDetail,
          ui,
          actions,
          this.onClickLink,
        )}
      />
    )
  }
}

function mapStateToProps(state: Object) {
  return {
    ui: state.ui,
    reservationDetail: state.reservationDetail,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...ReservationDetailActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Container),
)



// WEBPACK FOOTER //
// ./src/containers/organisms/ReservationSidebar/index.jsx